import PropTypes from 'prop-types';

// The return contract of useLoanChatTargets, shared by every surface that threads chatTargets
// through props.
export const chatTargetsPropType = PropTypes.shape({
  internalChatId: PropTypes.string,
  tpoChatId: PropTypes.string,
});
